import { useEffect, useRef } from 'react';

import { HOUSE_RULE_REQUIRED_EVENT } from '@/shared/api/consent-required';

import { useHouseRuleGate } from './HouseRuleGate';

/**
 * TRAD-3777 — 공통 응답 처리가 403 TERMS_008(하우스 룰 미동의 쓰기)을 받으면 쏘는 이벤트를 받아, 글쓰기 진입 때와 «같은» 하우스 룰
 * 다이얼로그를 연다(`useHouseRuleGate`). 실패한 쓰기를 대신 다시 보내지는 않는다 — 동의한 뒤 사용자가 다시 누른다.
 * 라우터 안(RootLayout)에 한 번만 둔다(G7 `ConsentRequiredRedirect` 옆). 다이얼로그가 떠 있는 동안 온 이벤트는 무시한다(동시 403 중복 방지).
 */
const HouseRuleRequiredListener = () => {
  const { ensureAccepted, dialog } = useHouseRuleGate();
  const busy = useRef(false);
  const ensureRef = useRef(ensureAccepted);
  ensureRef.current = ensureAccepted;

  useEffect(() => {
    const onRequired = () => {
      if (busy.current) return;
      busy.current = true;
      void ensureRef.current().finally(() => {
        busy.current = false;
      });
    };
    window.addEventListener(HOUSE_RULE_REQUIRED_EVENT, onRequired);
    return () => window.removeEventListener(HOUSE_RULE_REQUIRED_EVENT, onRequired);
  }, []);

  return dialog;
};

export default HouseRuleRequiredListener;
